import React, { useState } from 'react';
import { DropDownList } from '@progress/kendo-react-dropdowns';
import { useSelector } from 'react-redux';
import withValueField from './withValueField';
import { getWarehouseUnitTypes } from 'src/slices/warehouseUnitTypes';

const UnitTypesDropdown = ({
    unitType,
    onChange,
    visited,
    validationMessage,
    ...others
}) => {

    const [value, setValue] = useState(0);
    const DropDownWithValueField = withValueField(DropDownList);
    const handleChange = (event) => {
        setValue(event.target.value);

        if (onChange) {
          onChange(event);
        }
    };

    const unitTypes = useSelector(getWarehouseUnitTypes);

    return (
        <>
            <DropDownWithValueField onChange={handleChange} data={unitTypes} valueField="value" textField="description" value={value} {...others} />
        </>
    );
};

export default UnitTypesDropdown;